// Apolo IDE — useInlineSkills (sprint plan-tab-v1, E6).
//
// Cache do catálogo curado /api/plan/skills/inline (≈30 skills). Carrega
// uma vez por sessão e reutiliza. Refresh manual disponível.

import { useCallback, useEffect, useState } from 'react';
import { listInlineSkills } from '../lib/plan/api.js';

let CACHED = null;

export function useInlineSkills() {
  const [skills, setSkills] = useState(CACHED || []);
  const [loading, setLoading] = useState(!CACHED);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    const res = await listInlineSkills();
    setLoading(false);
    if (!res.ok) { setError(res.error || 'Falha ao carregar skills'); return; }
    const next = res.data?.skills ?? [];
    CACHED = next;
    setSkills(next);
  }, []);

  useEffect(() => {
    if (CACHED) return;
    refresh();
  }, [refresh]);

  return { skills, loading, error, refresh };
}
